<template>
  <footer class="wx-footer">
    &copy; {{ currentYear }} Powered by
    <a href="https://openit.gr/en/" target="_blank" rel="noopener">OpenIT</a>. All rights reserved.
  </footer>
</template>

<script>
export default {
  name: "MainFooter",
  data() {
    return {
      currentYear: new Date().getFullYear(),
    };
  },
};
</script>

<style scoped>
.wx-footer {
  padding: 18px 0 2px;
  text-align: center;
  font-size: 12px;
  color: var(--wx-text-3);
}

a {
  color: var(--wx-text-2);
  font-weight: 600;
  text-decoration: none;
}

a:hover {
  color: var(--wx-accent);
}
</style>
